import { useState, useEffect } from 'react';

/**
 * Hook to persist tab state across page refreshes using sessionStorage.
 * @param {string} key - A unique key for the tab state (e.g., the view name).
 * @param {string} defaultTab - The default tab if no state is saved.
 * @returns {[string, function]} - The current active tab and a setter function.
 */
export function usePersistentTab(key, defaultTab) {
  const fullKey = `sofera:tab:${key}`;
  
  const [activeTab, setActiveTab] = useState(() => {
    try {
      const saved = sessionStorage.getItem(fullKey);
      return saved || defaultTab;
    } catch (e) {
      console.warn('Failed to load tab state from sessionStorage:', e);
      return defaultTab;
    }
  });

  useEffect(() => {
    try {
      sessionStorage.setItem(fullKey, activeTab);
    } catch (e) {
      console.warn('Failed to save tab state to sessionStorage:', e);
    }
  }, [fullKey, activeTab]);

  return [activeTab, setActiveTab];
}
